import { useId } from "@floating-ui/react"
import classNames from "classnames"

import type {
  Ref,
  ComponentPropsWithoutRef,
} from "react"

import {
  forwardRef,
  useLayoutEffect,
} from "react"

import styles from "./Dialog.module.scss"
import { useDialogContext } from "./useDialogContext"

type Props = ComponentPropsWithoutRef<"div">

export const DialogBody = forwardRef<HTMLDivElement, Props>(
  function DialogBody(props: Props, propRef: Ref<HTMLDivElement>) {
    const {
      children,
      ...restProps
    } = props

    const { setDescriptionId } = useDialogContext()
    const id = useId()

    // Only sets `aria-describedby` on the Dialog root element
    // if this component is mounted inside it.
    useLayoutEffect(
      () => {
        setDescriptionId(id)
        return () => setDescriptionId(undefined)
      },
      [
        id,
        setDescriptionId,
      ],
    )

    const className = classNames(
      styles.dialogBody,
      restProps.className,
    )

    return (
      <div
        {...restProps}
        className={className}
        ref={propRef}
        id={id}
      >
        {children}
      </div>
    )
  },
)
